module.exports = __webpack_public_path__ + "static/media/30.85ab4697.png";


//////////////////
// WEBPACK FOOTER
// ./src/30.png
// module id = 472
// module chunks = 0